export default __webpack_public_path__ + "static/media/Poor-03.a16de37a.png";